import React, {useState, useEffect} from 'react'
import classNames from 'classnames/bind'

import './style.css'

export function TimedEvent({start, onConclusion}) {
    return <Animation start={start} onConclusion={onConclusion} animation="dummy" />
}

export function Reveal(props) {
    return <Animation {...props} animation="fadein" />
}

export function Ripple(props) {
    return <Animation {...props} animation="ripple" />
}

export function ZoomHover(props) {
    return <Animation {...props} start={0} duration={0} animation="zoom" />
}

export function Animation({children, start = 0, duration = 500, animation, onConclusion, ...props}) {
    const [enterSignal, enter] = useState(true)
    const [playSignal, play] = useState(false)
    const [exitSignal, exit] = useState(false)
    const classes = classNames({
        'animation-container': true,
        [`${animation}-enter`]: enterSignal,
        [`${animation}-enter-play`]: playSignal,
        [`${animation}-exit`]: exitSignal
    })

    start = start || start + 1

    useEffect(() => {
        enter(true)
        setTimeout(() => [play(true)], start)
        setTimeout(() => [enter(false), play(false), exit(true), onConclusion?.()], start + duration)
    }, [duration, start, onConclusion]);

    let style = props.style ?? {}
    if (duration) style = {
        transitionDuration: `${duration}ms`,
        animationDuration: `${duration}ms`,
        ...style,
    }

    return (
        <div {...props} style={style} className={classes}>{children}</div>
    )
}

export function Timeline({duration, gap, children}) {

    const quantize = (i, time) => i * time
    const timeline = (i) => quantize(i, duration) + quantize(i, gap)

    return children.map((child, i) => React.cloneElement(child, {
        start: timeline(child.props.start ?? i),
        duration: child.props.duration ?? duration,
    }))
}
